import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, str2arr, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {useAuthInfo} from "@/store/account.c";
import {WritePlan} from "@/pages/Plan/WritePlan";
import {PlanPageVO, useQueryPlanPage} from "@/service/plan.s";
import {ProgressBar} from "@/widget/ProgressBar/ProgressBar";
import {Avatar, AvatarGroup} from "@mui/material";
import Chip from "@mui/material/Chip";
import {ViewPlan} from "@/pages/Plan/ViewPlan";

export const PlanListPage = () => {
    const {
        mutate: planPageMutate,
        data: planPageData,
        isPending: planPagePending,
    } = useQueryPlanPage()
    const {id} = useAuthInfo()

    const columns: GridColDef<PlanPageVO>[] = [
        {field: "planName", headerName: "目标名称", flex: 0.5,},
        {
            field: "status",
            headerName: "目标状态",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
            renderCell: ({row: {status, statusId}}) => {
                let style = {}
                if (statusId == 1) {
                    style = {"& .MuiChip-label": {color: '#ff6692'}, backgroundColor: '#ffecf2 !important', border: 'none'};
                } else if (statusId == 2) {
                    style = {"& .MuiChip-label": {color: '#00ceb6'}, backgroundColor: '#e0f9f6 !important', border: 'none'};
                } else if (statusId == 3) {
                    style = {"& .MuiChip-label": {color: '#ffae1f'}, backgroundColor: '#fff5e4 !important', border: 'none'};
                }
                return <Chip label={status} variant={'filled'} size={'small'} sx={style}/>
            }
        },
        {
            field: "executor",
            headerName: "负责人",
            headerAlign: "center",
            align: "center",
            flex: 0.3
        },
        {
            field: "owners",
            headerName: "成员",
            headerAlign: "center",
            align: "center",
            display: "flex",
            flex: 0.6,
            renderCell: (({row: {owners}}) => {
                const newOwners: string[] = str2arr(owners, 'string')
                return <AvatarGroup sx={{
                    '& .MuiAvatarGroup-avatar': {
                        width: 32, height: 32, fontSize: 10, border: 'none',
                    }
                }} max={3}>
                    {newOwners?.map((owner: string, index: number) => <Avatar key={index} {...stringAvatar(owner)} />)}
                </AvatarGroup>
            })
        },
        {
            field: "startTime",
            headerName:
                "预计开始时间",
            headerAlign:
                "right",
            align:
                "right",
            valueFormatter:
                value => {
                    return formatTime("h", value)
                },
            flex: 0.5
        },
        {
            field: "endTime",
            headerName:
                "预计结束时间",
            headerAlign:
                "right",
            align:
                "right",
            valueFormatter:
                value => {
                    return formatTime("h", value)
                },
            flex: 0.5
        },
        {
            field: "ratio", headerName:
                "目标进度", flex:
                0.4, headerAlign:
                'center', valueGetter:
                (value, row) => row.ratio, type:
                'number', renderCell:
            ProgressBar
        },
        {
            field: "createdAt",
            headerName:
                "创建时间",
            headerAlign:
                "right",
            align:
                "right",
            valueFormatter:
                (value) => formatTime("D", value),
        },
    ]

    return (
        <ProTable<PlanPageVO>
            loading={planPagePending}
            renderDrawer={{view: <ViewPlan/>, write: <WritePlan/>}}
            columns={columns}
            data={planPageData?.data}
            onSearch={(params) => {
                planPageMutate(params);
            }}
            code={"plan"}
        />
    );
};
